<template>
  <div class="section">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/admin">Admin Settings</router-link></li>
        <li class="is-active"><router-link to="/admin/system-logs" aria-current="true">System Logs</router-link></li>
      </ul>
    </nav>
    <div class="container">
      <h1 class="title">System Logs</h1>
      
      <!-- Tab Navigation -->
      <div class="tabs is-boxed">
        <ul>
          <li :class="{ 'is-active': activeTab === 'backend' }">
            <a @click="setActiveTab('backend')">
              <span class="icon is-small">
                <i class="fas fa-server"></i>
              </span>
              <span>Backend Logs</span>
            </a>
          </li>
          <li :class="{ 'is-active': activeTab === 'lhdn' }">
            <a @click="setActiveTab('lhdn')">
              <span class="icon is-small">
                <i class="fas fa-exchange-alt"></i>
              </span>
              <span>LHDN API Logs</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Backend Logs Tab -->
      <div v-show="activeTab === 'backend'" class="tab-content">
        <BackendLogsContent />
      </div>

      <!-- LHDN Logs Tab -->
      <div v-show="activeTab === 'lhdn'" class="tab-content">
        <LHDNLogsContent />
      </div>
    </div>
  </div>
</template>

<script>
import BackendLogsContent from '@/components/admin/BackendLogsContent.vue';
import LHDNLogsContent from '@/components/admin/LHDNLogsContent.vue';

export default {
  name: 'SystemLogs',
  components: {
    BackendLogsContent,
    LHDNLogsContent
  },
  data() {
    return {
      activeTab: 'backend'
    };
  },
  mounted() {
    // Check if there's a tab specified in the route query
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab;
    }
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
      // Update the URL query parameter without navigating
      this.$router.replace({ 
        query: { ...this.$route.query, tab: tab } 
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.tab-content {
  padding-top: 1rem;
}

.tabs.is-boxed li.is-active a {
  background-color: #0a1821;
  border-color: #0a1821;
  color: white;
}

.tabs.is-boxed a {
  border: 1px solid #dbdbdb;
  border-radius: 4px 4px 0 0;
  color: #363636;
}

.tabs.is-boxed a:hover {
  background-color: #f5f5f5;
  border-color: #b5b5b5;
}
</style>
